<template class="full-height">
  <div class="view-point-app-container" style="position: relative; height: 100%; padding: 10px">
    <el-dialog
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <el-card class="box-card">
        <el-form ref="form" :model="form" :label-width="formLabelWidth">
          <el-form-item
            :label="funcName + '使用區域'"
            prop="countryAreaList"
            :rules="[{ required: true, message: '請輸入景點區域', trigger: 'change' }]"
          >
            <el-cascader
              clearable
              v-model="form.countryAreaList"
              :props="{ checkStrictly: true, expandTrigger: 'hover' }"
              style="width: 100%"
              placeholder="請選擇"
              filterable
              :options="travelAttractionsMenu"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item
            :label="funcName + '名稱'"
            prop="viewPointName"
            :rules="[{ required: true, message: '請輸入景點名稱', trigger: 'blur' }]"
          >
            <el-input v-model="form.viewPointName"></el-input>
          </el-form-item>

          <el-form-item :label="funcName + '座標'">
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="北緯(lat)"
                  prop="lat"
                  :rules="[
                    {
                      required: true,
                      message: '請輸座標北緯度',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '座標緯度必須為數字' },
                  ]"
                >
                  <el-input v-model.number="form.lat"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="東經(lng)"
                  prop="lng"
                  :rules="[
                    {
                      required: true,
                      message: '請輸座標東經度',
                      trigger: 'blur',
                    },
                    { type: 'number', message: '座標經度必須為數字' },
                  ]"
                >
                  <el-input v-model.number="form.lng"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveData">確 定</el-button>
      </span>
    </el-dialog>

    <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item :label="funcName + '使用區域'">
          <el-cascader
            clearable
            v-model="listQuery.countryAreaList"
            :props="{ checkStrictly: true, expandTrigger: 'hover' }"
            style="width: 100%"
            placeholder="請選擇"
            filterable
            :options="travelAttractionsMenu"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item label="查詢">
          <el-input
            v-model="listQuery.qry"
            placeholder="輸入景點名稱"
            @keyup.enter.native="getList"
          />
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="getList">查詢</el-button>
        </el-form-item>

        <el-form-item>
          <el-button type="success" @click="addData">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            style="cursor: pointer"
            :loading="listLoading"
            type="success"
            icon="el-icon-refresh-left"
            circle
            @click="refresh()"
          ></el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        height="100%"
      >
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="區域" width="210">
          <template slot-scope="scope">
            <el-cascader
              :disabled="true"
              clearable
              v-model="scope.row.countryAreaList"
              :props="{ checkStrictly: true, expandTrigger: 'hover' }"
              style="width: 100%"
              placeholder="請選擇"
              filterable
              :options="travelAttractionsMenu"
            >
            </el-cascader>
          </template>
        </el-table-column>

        <el-table-column align="left" label="景點名稱" width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.viewPointName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="funcName + '座標北緯度'" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.lat }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="funcName + '座標東經度'" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.lng }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button type="primary" @click="editData(scope.row)">編輯</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total > 0"
      style="padding-top: 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'

import { getViewPoints, saveViewPoint, getTravelAttractionsCascaderMenu } from '@/api/travel'

var defaultForm = {
  countryAreaList: [],
  viewPointName: '',
  lat: 0,
  lng: 0,
}

export default {
  name: 'ViewPoint',
  components: {
    Pagination,
  },
  data() {
    return {
      travelAttractionsMenu: [],
      funcName: '景點',
      dialogTopMargin: '5%',
      formLabelWidth: '120px',
      form: {},
      dialogLoading: false,
      dialogVisible: false,
      listLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
        countryAreaList: [],
      },
      total: 0,
      list: [],
    }
  },
  async created() {
    this.form = defaultForm
    await this.getTravelAttractionsCascaderMenu()
    await this.getList()
  },
  methods: {
    async refresh() {
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
      await this.getList()
    },
    async getTravelAttractionsCascaderMenu() {
      let resp = await getTravelAttractionsCascaderMenu()
      //只需要到國家
      if (resp.data) {
        this.travelAttractionsMenu = resp.data
        // resp.data.forEach((f) => {
        //   if (f.children) {
        //     f.children.forEach((c) => {
        //       c.children = null;
        //     });
        //   }
        // });
      }
      this.travelAttractionsMenu = resp.data
    },
    addData() {
      let vm = this
      vm.form = JSON.parse(JSON.stringify(defaultForm))
      this.dialogVisible = true
    },
    editData(row) {
      this.form = row
      this.dialogVisible = true
    },
    async saveData() {
      let vm = this
      if (!confirm(`確定要儲存【${vm.funcName}}】資料?`)) {
        return
      }

      this.$refs['form'].validate(async valid => {
        if (valid) {
          vm.dialogLoading = true
          let resp = await saveViewPoint(this.form)
          await vm.getList()
          this.dialogVisible = false
          vm.dialogLoading = false
          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getList() {
      this.listLoading = true
      let resp = await getViewPoints(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.total
      this.listLoading = false
    },
  },
}
</script>

<style scoped>
.full-height {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}

/deep/ .el-cascader input[type='text']:disabled {
  color: blue !important;
}
</style>
